<div id="secondaryHeaderBreadCrumb">
  <ng-container *ngIf="loading">
    <nz-skeleton
      [nzTitle]="true"
      [nzActive]="true"
      [nzParagraph]="false"
    ></nz-skeleton>
  </ng-container>
  <ng-container *ngIf="!loading">
    <nz-breadcrumb [nzSeparator]="iconTemplate">
      <nz-breadcrumb-item
        *ngFor="let breadCrumbSection of breadCrumb; let i = index"
      >
        <a
          *ngIf="breadCrumbSection.link && !breadCrumbSection.isRouterLink"
          [href]="breadCrumbSection.link"
          (click)="onBreadcrumbClick(breadCrumbSection.name)"
          >{{ breadCrumbSection.name }}</a
        >
        <a
          *ngIf="breadCrumbSection.link && breadCrumbSection.isRouterLink"
          routerLink="{{ breadCrumbSection.link }}"
          routerLinkActive="active"
          (click)="onBreadcrumbClick(breadCrumbSection.name)"
          >{{ breadCrumbSection.name }}</a
        >
        <span *ngIf="!breadCrumbSection.link">{{
          breadCrumbSection.name
        }}</span>
      </nz-breadcrumb-item>
    </nz-breadcrumb>
  </ng-container>
</div>

<ng-template #iconTemplate> <span class="separatorIcon">></span> </ng-template>
